import React, { Component, Fragment, lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import axios from "axios";
import "./App.css";

import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import FullScreenMessage from "./components/FullScreenMessage.js";
import MediaManager from "./components/MediaManager.js";
import FrameImages from "./components/FrameImages.js";
import Profile from "./Profile.js";
import ProfileEdit from "./ProfileEdit.js";
import Order from "./Order.js";
// import Teleprompt from './Teleprompt.js';
import PasswordChange from "./ChangePassword.js";
import Static from "./Static";
import EditFrames from "./page/admin/edit-frames";
import EditAboutPage from "./page/admin/edit-about-page";
import AddressChange from "./ChangeAddress.js";
import FrameBuilder from "./components/FrameBuilder.js";
import Cart from "./Cart.js";
import Home from "./Home.js";
import Login from "./Login.js";
import ContactUs from "./ContactUs.js";
import Customers from "./Customers.js";
import Orders from "./Orders.js";
import Register from "./Register.js";
import RestorePassword from "./RestorePassword";
import ResendActivationLink from "./ResendActivationLink.js";
import ArtPrinting from "./page/art-printing/art-printing";
import Server from "./Server";
import AboutUsNew from "./page/about-us";
import CanvasNew from "./page/canvas";

import Calculator from "./components/PriceCalculator.js";
import AdminPriceDefinitionList from "./components/AdminPriceDefinitionList";

import Error404 from "./components/Error404";

import utilities from "./components/Utilities";
import Loader from "./Loader";
let Utilities = new utilities();

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      loading: true,
    };

    window.region =
      window.location.href.indexOf("frameit.com.sg") !== -1 ||
      window.location.href.indexOf("localhost:3000") !== -1
        ? "SG"
        : "MY";
    window.currency = window.region === "SG" ? "$" : "RM";
    window.countryName = window.region === "SG" ? "Singapore" : "Malaysia";
    window.stripeKey = "pk_live_SuAM0hDnyMAf45jReH1aTCsW00QPXVT5Pv";

    if (
      window.location.href.includes("staging.frameit.com.sg") ||
      window.location.href.includes("localhost:3000")
    ) {
      console.log("stripe test");
      window.stripeKey = "pk_test_hn1gb7vbRpALjUJnhdqIie3v00Y2TKrhOz";
    }
    console.log("YOU ARE IN " + window.region);
  }

  componentDidMount() {
    if (window.location.pathname.toLowerCase().includes("art-printing")) {
      document.title = "Fine Art Printing Singapore | FrameIT";
    }
    if (window.location.pathname.toLowerCase().includes("canvas-stretching")) {
      document.title = "High Quality Canvas Stretching in Singapore | FrameIT";
    }
    window.globalVars.definitons && this.setState({ loading: false });

    let ua = navigator.userAgent;
    let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    this.setState({ ie: is_ie });

    if (is_ie) {
      document.getElementsByTagName("body")[0].setAttribute("data-ie", "true");
    }

    let currentPage = window.location.href;

    let user = localStorage.getItem("user");

    if (
      currentPage.indexOf("login") === -1 &&
      (user === null || user === undefined)
    ) {
      window.globalVars.previousPage = currentPage;
      localStorage.setItem("previousPage", JSON.stringify(currentPage));
    } else {
      localStorage.removeItem("previousPage");
    }
  }

  componentWillMount() {
    let server = new Server();

    window.globalVars = {
      server: server,
      pageTitleBefore: "",
      pageTitleAfter:
        " | FrameIT " + (window.region === "SG" ? "Singapore" : "Malaysia"),
    };

    let user = JSON.parse(localStorage.getItem("user"));

    if (user !== null && user !== undefined) {
      this.setState({
        user: user,
      });
      window.globalVars.user = user;
    }

    let authToken = localStorage.getItem("authToken");

    if (authToken !== null && authToken !== undefined) {
      window.globalVars.server.api({
        method: "post",
        url: "api/user/current",
        then: function (res) {
          let user = res.data.user;
          this.setState({
            loggedIn: true,
            user: user,
          });

          localStorage.setItem("user", JSON.stringify(user));

          window.globalVars.loggedIn = true;
          window.globalVars.user = user;
        }.bind(this),
        catch: function (e) {
          window.globalVars.loggedIn = false;
          this.setState({ loggedIn: false });
        }.bind(this),
        ignoreUnauthorized: true,
      }, false);
    }

    // Loading admin settings

    let priceDefinitions = JSON.parse(localStorage.getItem("priceDefinitions"));
    let updatedTimestamp = JSON.parse(
      localStorage.getItem("priceDefinitionsTimestmap")
    );
    let frameImages = JSON.parse(localStorage.getItem("frameImages"));

    if (
      Utilities.isENU(priceDefinitions) ||
      Utilities.isENU(updatedTimestamp) ||
      Date.now() > parseInt(updatedTimestamp) + 900000
    ) {
      axios
        .get("/api/admin-settings")
        .then(
          function (res) {
            res.data.data
              .filter((item) => item.type === "frame")
              .map((item) => {
                item.description =
                  "<strong>" +
                  item.name +
                  "</strong> (" +
                  item.frameWidth +
                  " cm Wide)";
                return item;
              });

            let dateNow = JSON.stringify(Date.now());

            localStorage.setItem(
              "priceDefinitions",
              JSON.stringify(res.data.data)
            );
            localStorage.setItem(
              "priceDefinitionsTimestmap",
              JSON.stringify(dateNow)
            );

            window.globalVars.definitons = res.data.data;

            this.setState({ loading: false });
            // window.location.reload();
          }.bind(this)
        )
        .catch(function (e) {}.bind(this));

      axios
        .get("/api/frame-image")
        .then(
          function (res) {
            localStorage.setItem("frameImages", JSON.stringify(res.data.data));
            window.globalVars.frameImages = res.data.data;
          }.bind(this)
        )
        .catch(function (e) {}.bind(this));
    } else {
      window.globalVars.definitons = priceDefinitions;
      window.globalVars.frameImages = frameImages;
    }
  }

  render() {
    return this.state.loading ? (
      <Loader />
    ) : (
      <div data-ie={this.state.ie}>
        <BrowserRouter>
          <div>
            <Navbar loggedIn={this.state.loggedIn} user={this.state.user} />
            <Switch>
              <Route path="/" component={Home} exact></Route>
              <Route
                path="/order/placed/:orderId"
                component={() => (
                  <FullScreenMessage
                    name="Cart Content"
                    hideAddButton={true}
                    readOnlyFields={["delete"]}
                    singleFields={[
                      { name: "Top of Page Message", dbName: "cart-message" },
                    ]}
                    strField={true}
                    fields={[]}
                    dbgroup="cart-page"
                    type="order-placed"
                    key="order-placed"
                  />
                )}
                exact
              />
              {/*<Route path="/prompt" component={ Teleprompt } exact></Route>*/}
              <Route
                path="/order/:orderId/:key"
                component={Order}
                exact
              ></Route>
              <Route path="/order/:orderId" component={Order} exact></Route>
              <Route path="/login" component={Login} exact></Route>
              <Route
                path="/resend"
                component={ResendActivationLink}
                exact
              ></Route>
              <Route path="/register" component={Register} exact></Route>
              <Route
                path="/restore/email"
                exact
                component={() => <RestorePassword type="email" />}
              ></Route>
              <Route
                path="/restore/password/:userId/:hash"
                exact
                component={() => <RestorePassword type="password" />}
              ></Route>
              <Route path="/cart" component={Cart} exact></Route>
              <Route
                path="/terms"
                component={() => <Static type="terms" />}
                exact
              ></Route>
              <Route
                path="/shipping"
                component={() => <Static type="shipping" />}
                exact
              ></Route>
              <Route
                path="/privacy-policy"
                component={() => <Static type="privacy-policy" />}
                exact
              ></Route>
              <Route path="/contact-us" component={ContactUs} exact></Route>
              <Route path="/canvas-stretching" exact>
                <CanvasNew />
              </Route>
              <Route path="/about-us" exact>
                <AboutUsNew />
              </Route>
              <Route path="/profile" component={Profile} exact></Route>
              <Route path="/profile/edit" component={ProfileEdit} exact></Route>
              <Route
                path="/profile/edit/:id"
                component={ProfileEdit}
                exact
              ></Route>
              <Route
                path="/profile/password/edit"
                component={PasswordChange}
                exact
              ></Route>
              <Route
                path="/profile/address/edit/:addressId"
                component={AddressChange}
                exact
              ></Route>

              <Route path="/calculator" component={Calculator} exact></Route>

              <Route
                path="/admin/latest-work"
                component={() => (
                  <MediaManager type="latest-work" title="Latest work" />
                )}
              />

              <Route
                path="/admin/frame-images"
                component={() => (
                  <FrameImages type="frame-images" title="Frame Images" />
                )}
              />

              <Route
                path="/admin/edit/home"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Homepage Content"
                    hideAddButton={true}
                    readOnlyFields={["delete"]}
                    singleFields={[
                      { name: "Frames crafted", dbName: "frames-crafted" },
                      { name: "Supplier email", dbName: "supplier-email" },
                      { name: "Hero title", dbName: "hero-title" },
                      { name: "Hero subhead", dbName: "hero-subhead" },
                      { name: "Hero button", dbName: "hero-button" },
                      { name: "HDIW title", dbName: "hdiw-title" },
                      { name: "HDIW subhead", dbName: "hdiw-subhead" },
                      {
                        name: "HDIW feature 1 title",
                        dbName: "hdiw-feature-1-title",
                      },
                      {
                        name: "HDIW feature 1 description",
                        dbName: "hdiw-feature-1-description",
                      },
                      {
                        name: "HDIW feature 2 title",
                        dbName: "hdiw-feature-2-title",
                      },
                      {
                        name: "HDIW feature 2 description",
                        dbName: "hdiw-feature-2-description",
                      },
                      {
                        name: "HDIW feature 3 title",
                        dbName: "hdiw-feature-3-title",
                      },
                      {
                        name: "HDIW feature 3 description",
                        dbName: "hdiw-feature-3-description",
                      },
                      {
                        name: "HDIW feature 4 title",
                        dbName: "hdiw-feature-4-title",
                      },
                      {
                        name: "HDIW feature 4 description",
                        dbName: "hdiw-feature-4-description",
                      },
                      {
                        name: "Latest work title",
                        dbName: "latest-work-title",
                      },
                    ]}
                    strField={true}
                    fields={[]}
                    dbgroup="home-page"
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/edit/cart"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Cart Content"
                    hideAddButton={true}
                    readOnlyFields={["delete"]}
                    singleFields={[
                      { name: "Top of Page Message", dbName: "cart-message" },
                    ]}
                    strField={true}
                    fields={[]}
                    dbgroup="cart-page"
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/edit/checkout"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Checkout Content"
                    hideAddButton={true}
                    readOnlyFields={["delete"]}
                    singleFields={[
                      {
                        name: "After order number message",
                        dbName: "checkout-message",
                      },
                    ]}
                    strField={true}
                    fields={[]}
                    dbgroup="checkout-page"
                  />
                )}
                exact
              ></Route>

              <Route path="/admin/edit/about" exact>
                <EditAboutPage />
              </Route>

              <Route
                path="/admin/main-settings"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Main settings"
                    hideAddButton={true}
                    readOnlyFields={["delete"]}
                    singleFields={[
                      {
                        name: "Rounding increment for artwork size (cm)",
                        dbName: "rounding-increment-for-artwork-size",
                      },
                      {
                        name: "Frame allowance per edge (cm)",
                        dbName: "frame-allowance-per-edge",
                      },
                      {
                        name: "Frame cut width (material lost per cut, cm)",
                        dbName: "frame-cut-width",
                      },
                      {
                        name: "Tax (%)",
                        dbName: "tax",
                      },
                    ]}
                    fields={[]}
                    dbgroup="-"
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/labor-costs"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Labor costs"
                    fields={["name", "area", "maxDim", "price"]}
                    dbgroup="labor-cost"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/email"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Admin emails"
                    fields={["name"]}
                    dbgroup="admin-email"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/matte-colors"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Matte colors"
                    fields={["adminId", "name", "rgb", "oversizedMattColor"]}
                    dbgroup="matte-color"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/hanging-components"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Hanging components"
                    fields={[
                      "component",
                      "price",
                      "maxDimSmall",
                      "maxDimLarge",
                    ]}
                    dbgroup="hanging-components"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/other-costs"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Other costs"
                    fields={["name", "price"]}
                    dbgroup="other-cost"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/backings"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Backings"
                    fields={["name", "price"]}
                    dbgroup="backing"
                    readOnlyFields={["name", "delete"]}
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/popular-sizes"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Popular sizes"
                    fields={["name", "width", "height"]}
                    dbgroup="popular-size"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/glazings"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Glazings"
                    fields={["name", "price"]}
                    dbgroup="glazing"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route path="/admin/frames" exact>
                <EditFrames />
              </Route>

              <Route path="/art-printing" exact>
                <Suspense fallback="<div>...loading</div>">
                  <ArtPrinting />
                </Suspense>
              </Route>

              <Route
                path="/admin/matte-suggestions"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Matte width suggestions"
                    fields={["from", "to", "suggestedWidth"]}
                    dbgroup="matte-suggestion"
                    singleFields={[
                      {
                        name: "Matte overlap per edge (cm)",
                        dbName: "matte-overlap",
                      },
                    ]}
                  />
                )}
                exact
              ></Route>

              <Route
                path="/admin/matte-costs"
                component={() => (
                  <AdminPriceDefinitionList
                    name="Matte costs"
                    fields={["largestDim", "smallestDim", "price"]}
                    dbgroup="matte-cost"
                    singleFields={[]}
                  />
                )}
                exact
              ></Route>

              <Route path="/admin/orders" component={Orders} exact>
                {" "}
              </Route>
              <Route path="/admin/customers" component={Customers} exact>
                {" "}
              </Route>
              <Route path="/admin/customers/:id" component={Profile} exact>
                {" "}
              </Route>

              <Route
                path="/account/activate/:userId/:hash"
                component={() => (
                  <FullScreenMessage
                    type="activate-account"
                    key="activate-account"
                  />
                )}
                exact
              />

              <Route
                path="/order/failed"
                component={() => (
                  <FullScreenMessage type="order-failed" key="order-failed" />
                )}
                exact
              />

              <Route path="/build/:step/:id" component={FrameBuilder} />

              <Route component={Error404} />
            </Switch>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js